<template>
  <main class="payment_detail_main">
    <div
      data-v-05ab5af4=""
      class="modal_wrap bottom_modal"
      autoestimation=""
      :class="{ on: isOpen }"
      v-if="mobilePlanDetail"
    >
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <div class="payment_detail_pop">
            <div class="payment_detail_wrap">
              <div class="payment_info_1">
                <div class="d_info">
                  <div class="d_txt_1">{{ mobilePlanDetail.planName }}</div>
                  <div class="d_txt_2">
                    <div class="d_txt_list">
                      <div class="list_1">
                        <img
                          :src="
                            require(`@/assets/front/images/mobile/i_phonefee_op_phone.svg`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="list_2">{{ mobilePlanDetail.voice }}</div>
                    </div>
                    <div class="d_txt_list">
                      <div class="list_1">
                        <img
                          :src="
                            require(`@/assets/front/images/mobile/i_phonefee_op_msg.svg`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="list_2">{{ mobilePlanDetail.sms }}</div>
                    </div>
                    <div class="d_txt_list">
                      <div class="list_1">
                        <img
                          :src="
                            require(`@/assets/front/images/mobile/i_phonefee_op_wifi.svg`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="list_2">{{ mobilePlanDetail.data }}</div>
                    </div>
                    <div class="d_txt_list">
                      <div class="list_1">
                        <img
                          :src="
                            require(`@/assets/front/images/mobile/i_phonefee_op_video.svg`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="list_2">{{ mobilePlanDetail.video }}</div>
                    </div>
                  </div>
                  <div class="d_txt_3">
                    <div class="list_1">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_textinfo.svg`)
                        "
                        alt=""
                      />
                    </div>
                    <div
                      class="list_2"
                      v-if="mobilePlanDetail.explainCd == 'U_1M'"
                    >
                      {{ speedTxt.U_1M.content }}
                    </div>
                    <div
                      class="list_2"
                      v-if="mobilePlanDetail.explainCd == '1M'"
                    >
                      {{ speedTxt._1M.content }}
                    </div>
                    <div
                      class="list_2"
                      v-if="mobilePlanDetail.explainCd == '3M'"
                    >
                      {{ speedTxt._3M.content }}
                    </div>
                    <div
                      class="list_2"
                      v-if="mobilePlanDetail.explainCd == '5M'"
                    >
                      {{ speedTxt._5M.content }}
                    </div>
                    <div
                      class="list_2"
                      v-if="mobilePlanDetail.explainCd == 'O_10M'"
                    >
                      {{ speedTxt.O_10M.content }}
                    </div>
                  </div>
                  <div class="d_txt_4">
                    <span>월정액</span
                    >{{ toCurrency(mobilePlanDetail.price) }}원
                  </div>
                  <div class="d_txt_5">
                    <span>공시지원</span
                    >{{ toCurrency(mobilePlanDetail.supportMoney) }}원
                  </div>
                </div>
              </div>
              <div class="payment_info_2">
                <div
                  class="payment_spec_1"
                  v-html="
                    $options.filters.nl2br(
                      decodeBase64(mobilePlanDetail.planContents),
                    )
                  "
                ></div>
              </div>
              <div class="payment_info_3">
                <div class="info_txt">
                  ※선택된 요금제는 요금유지기간 이후 적용됩니다.
                </div>
              </div>
            </div>
            <div class="btm_btn">
              <div class="btn_wrap">
                <button class="btn bo" @click.stop.prevent="close">
                  돌아가기
                </button>
                <button class="btn" @click.stop.prevent="select">
                  요금제 선택하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
export default {
  name: 'paymentDetailModal',
  props: {
    mobilePlanDetail: Object,
  },
  components: {},
  data() {
    return {
      isOpen: false,
      speedTxt: {
        U_1M: {
          title: '1Mbps 미만',
          content: '카톡 텍스트는 원활! 사진전송은 느려요.',
        },
        _1M: { title: '1Mbps', content: '3G 보다 조금 느린 정도에요.' },
        _3M: { title: '3Mbps', content: '영상을 720p 화질로 볼 수 있어요.' },

        _5M: {
          title: '5Mbps',
          content: '영상을 1080p 화질로 볼 수 있어요.',
        },

        O_10M: {
          title: '10Mbps',
          content: '영상을 고화질로 끊김 없이 볼 수 있어요.',
        },
      },
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  computed: {},
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    decodeBase64(val) {
      return util.decodeBase64(val);
    },
    close() {
      this.$emit('close');
    },
    select() {
      this.$emit('select');
    },
  },
};
</script>
